
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|3925|8077|8231)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
